import React from 'react';
import * as _ from 'lodash';
import { deleteControlCode } from '../utilities/stringUtil';
import { FormElement } from './CommonFormComponents';
import { FormInput } from './FormInput';

/**
 * 電話番号入力フォーム
 * @param value {string} // 電話番号
 * @param handleOnChange {function} // 入力値セット
 * @param setKey {string} // 入力値セットキー名
 * @param error {string} // バリデーションメッセージ
 */
export class Tel extends React.Component {
  constructor(props) {
    super(props);

    // 電話番号を3つのinputへわける
    const splitedNumber = props.value ? props.value.split('-') : '';
    const prefixNumber = splitedNumber[0] || '';
    const cityCode = splitedNumber[1] || '';
    const subscriberNumber = splitedNumber[2] || '';

    this.state = {
      prefixNumber,
      cityCode,
      subscriberNumber,
      tel: props.value,
    };

    this.handlePrefixNumberOnChange = this.handlePrefixNumberOnChange.bind(
      this
    ); // 左の入力イベント
    this.handleCityCodeOnChange = this.handleCityCodeOnChange.bind(this); // 中央の入力イベント
    this.handleSubscriberNumberOnChange = this.handleSubscriberNumberOnChange.bind(
      this
    ); // 右の入力イベント
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // 初期値が設定されていた場合はselectedへセット
    if (nextProps.value !== this.state.tel) {
      // 電話番号を3つのinputへわける
      const splitedNumber = nextProps.value ? nextProps.value.split('-') : '';
      const prefixNumber = splitedNumber[0] || '';
      const cityCode = splitedNumber[1] || '';
      const subscriberNumber = splitedNumber[2] || '';

      this.setState({
        prefixNumber,
        cityCode,
        subscriberNumber,
        tel: nextProps.value,
      });
    }
  }

  /**
   * 左の入力イベント
   * 3つの入力値を結合して返却
   */
  handlePrefixNumberOnChange = e => {
    const e_target_value = deleteControlCode(e.target.value);
    this.setState({ prefixNumber: e_target_value });
    if (this.props.handleOnChange) {
      let result = `${e_target_value}-${this.state.cityCode}-${
        this.state.subscriberNumber
      }`;
      result = result == '--' ? '' : result;
      this.props.handleOnChange(this.props.setKey, result);
    }
  };

  handleCityCodeOnChange = e => {
    const e_target_value = deleteControlCode(e.target.value);
    this.setState({ cityCode: e_target_value });
    if (this.props.handleOnChange) {
      let result = `${this.state.prefixNumber}-${e_target_value}-${
        this.state.subscriberNumber
      }`;
      result = result == '--' ? '' : result;
      this.props.handleOnChange(this.props.setKey, result);
    }
  };

  handleSubscriberNumberOnChange = e => {
    const e_target_value = deleteControlCode(e.target.value);
    this.setState({ subscriberNumber: e_target_value });
    if (this.props.handleOnChange) {
      let result = `${this.state.prefixNumber}-${
        this.state.cityCode
      }-${e_target_value}`;
      result = result == '--' ? '' : result;
      this.props.handleOnChange(this.props.setKey, result);
    }
  };

  render() {
    const _validate = e => {
      if (this.props.validate) {
        this.props.validate(e);
      }
    };

    const isEmptyAndDisabled = () => {
      return (
        this.props.readOnly &&
        _.isEmpty(this.state.prefixNumber) &&
        _.isEmpty(this.state.cityCode) &&
        _.isEmpty(this.state.subscriberNumber)
      );
    };

    /**
     * FormList配下ではない時にFormList配下と同様のinput styleを表示する
     * FormInputに置き換えた際の影響調査ができなかったためisSearchで切り分けている
     */
    if (this.props.isSearch) {
      return (
        <FormElement validate={this.props.error}>
          {!isEmptyAndDisabled() && (
            <label htmlFor='tel' className='input-tel'>
              <FormInput
                short
                type='text'
                name='prefixNumber'
                placeholder={this.props.readOnly ? '' : '03'}
                maxLength={5}
                disabled={this.props.readOnly}
                value={this.state.prefixNumber}
                onChange={this.handlePrefixNumberOnChange}
                onBlur={_validate}
              />
              <span>-</span>
              <FormInput
                short
                type='text'
                name='cityCode'
                placeholder={this.props.readOnly ? '' : '1234'}
                maxLength={4}
                disabled={this.props.readOnly}
                value={this.state.cityCode}
                onChange={this.handleCityCodeOnChange}
                onBlur={_validate}
              />
              <span>-</span>
              <FormInput
                short
                type='text'
                name='subscriberNumber'
                placeholder={this.props.readOnly ? '' : '5678'}
                maxLength={4}
                disabled={this.props.readOnly}
                value={this.state.subscriberNumber}
                onChange={this.handleSubscriberNumberOnChange}
                onBlur={_validate}
              />
            </label>
          )}
        </FormElement>
      );
    }

    return (
      <FormElement
        validate={this.props.error}
        ccusComponent={this.props.ccusComponent}
        info={this.props.info || ''}
      >
        {!isEmptyAndDisabled() && (
          <label htmlFor='tel' className='input-tel'>
            <input
              type='text'
              name='prefixNumber'
              placeholder={this.props.readOnly ? '' : '03'}
              maxLength={5}
              disabled={this.props.readOnly}
              value={this.state.prefixNumber}
              onChange={this.handlePrefixNumberOnChange}
              onBlur={_validate}
            />
            <span>-</span>
            <input
              type='text'
              name='cityCode'
              placeholder={this.props.readOnly ? '' : '1234'}
              maxLength={4}
              disabled={this.props.readOnly}
              value={this.state.cityCode}
              onChange={this.handleCityCodeOnChange}
              onBlur={_validate}
            />
            <span>-</span>
            <input
              type='text'
              name='subscriberNumber'
              placeholder={this.props.readOnly ? '' : '5678'}
              maxLength={4}
              disabled={this.props.readOnly}
              value={this.state.subscriberNumber}
              onChange={this.handleSubscriberNumberOnChange}
              onBlur={_validate}
            />
          </label>
        )}
      </FormElement>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tel.jsx